import { getAppointmentTitle } from '../utils/text'

import { useNode } from './useNode'
import { useServiceName } from './useServiceName'

export const useAppointmentTitle = (
  nodeId?: string | undefined,
  serviceId?: number | undefined
): string | undefined => {
  const { node } = useNode(nodeId)
  const { name: serviceName } = useServiceName(serviceId)

  return getAppointmentTitle(node, serviceName)
}
